import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormServicesCountries } from '../components/Form'
import { apiList } from '../domain/api'
import { nameActions } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../hooks/toast'

const ServicesCountriesUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  const [servicesCountryItem, setServicesCountryItem] = useState<
    ServicesCountriesApiResponse | undefined
  >()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiList(id))
        setServicesCountryItem(response.data)
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao carregar o país de serviço',
          description:
            'Houve um erro ao carregar o país de serviço, tente novamente mais tarde!'
        })
        history.push(nameActions.read.to)
      } finally {
        disableLoading()
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      {servicesCountryItem && (
        <FormServicesCountries
          typeForm="update"
          initialValues={{
            idUpdate: Number(servicesCountryItem.id),
            ...servicesCountryItem
          }}
        />
      )}
    </Container>
  )
}

export default ServicesCountriesUpdate
